import React from 'react';
import { XIcon, EditIcon, TrashIcon, DownloadIcon, CalendarIcon, TagIcon, MapPinIcon, AlertTriangleIcon } from 'lucide-react';
interface AssetDetailModalProps {
  asset: any;
  isOpen: boolean;
  onClose: () => void;
}
export const AssetDetailModal: React.FC<AssetDetailModalProps> = ({
  asset,
  isOpen,
  onClose
}) => {
  if (!isOpen || !asset) return null;
  // Function to handle edit asset
  const handleEditAsset = () => {
    alert(`Edit aset ${asset.id} - ${asset.name}`);
    onClose();
  };
  // Function to handle delete asset
  const handleDeleteAsset = () => {
    const confirmed = window.confirm(`Apakah Anda yakin ingin menghapus aset ${asset.id} - ${asset.name}?`);
    if (confirmed) {
      alert(`Aset ${asset.id} berhasil dihapus`);
      onClose();
    }
  };
  // Function to handle download asset details
  const handleDownloadDetails = () => {
    alert(`Detail aset ${asset.id} berhasil diunduh`);
  };
  // Additional asset details
  const assetDetails = {
    serialNumber: `SN-${Math.floor(Math.random() * 10000000)}`,
    manufacturer: asset.category === 'Server & Komputasi' ? 'Dell Technologies' : asset.category === 'Software & Lisensi' ? 'Oracle Corporation' : asset.category === 'Jaringan & Komunikasi' ? 'Cisco Systems' : asset.category === 'Keamanan Siber' ? 'Fortinet' : 'VMware Inc.',
    model: asset.category === 'Server & Komputasi' ? 'PowerEdge R740' : asset.category === 'Software & Lisensi' ? 'Database Enterprise 19c' : asset.category === 'Jaringan & Komunikasi' ? 'Catalyst 9300' : asset.category === 'Keamanan Siber' ? 'FortiGate 100F' : 'vSphere 7.0',
    purchaseDate: '2024-08-15',
    warrantyEnd: '2027-08-15',
    value: asset.category === 'Server & Komputasi' ? 'Rp 350.000.000' : asset.category === 'Software & Lisensi' ? 'Rp 275.000.000' : asset.category === 'Jaringan & Komunikasi' ? 'Rp 150.000.000' : asset.category === 'Keamanan Siber' ? 'Rp 180.000.000' : 'Rp 450.000.000',
    condition: asset.status === 'Aktif' ? 'Baik' : asset.status === 'Perlu Perawatan' ? 'Perlu Pemeliharaan' : asset.status === 'Akan Habis' ? 'Baik (Lisensi Akan Habis)' : 'Rusak',
    lastMaintenance: '2026-01-10',
    nextMaintenance: '2026-07-10',
    notes: asset.status === 'Kritis' ? 'Aset memerlukan penggantian segera.' : asset.status === 'Perlu Perawatan' ? 'Jadwalkan pemeliharaan dalam 30 hari ke depan.' : asset.status === 'Akan Habis' ? 'Lisensi akan berakhir dalam 60 hari.' : 'Aset dalam kondisi baik dan berfungsi normal.'
  };
  return <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4" data-id="element-1436">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-4xl max-h-[90vh] overflow-hidden" data-id="element-1437">
        <div className="p-4 border-b border-gray-200 flex justify-between items-center bg-neutral-light" data-id="element-1438">
          <h2 className="text-xl font-bold text-secondary" data-id="element-1439">Detail Aset</h2>
          <button onClick={onClose} className="p-1 rounded-full hover:bg-gray-200 transition-colors" data-id="element-1440">
            <XIcon size={20} className="text-gray-500" data-id="element-1441" />
          </button>
        </div>
        <div className="overflow-y-auto p-6" style={{
        maxHeight: 'calc(90vh - 130px)'
      }} data-id="element-1442">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-6" data-id="element-1443">
            <div className="lg:col-span-2 space-y-6" data-id="element-1444">
              <div className="flex justify-between items-start" data-id="element-1445">
                <div data-id="element-1446">
                  <h3 className="text-2xl font-bold text-secondary mb-1" data-id="element-1447">
                    {asset.name}
                  </h3>
                  <div className="flex items-center text-sm text-gray-600 mb-2" data-id="element-1448">
                    <TagIcon size={16} className="mr-1" data-id="element-1449" />
                    <span className="mr-2" data-id="element-1450">{asset.id}</span>
                    <MapPinIcon size={16} className="mr-1 ml-2" data-id="element-1451" />
                    <span data-id="element-1452">{asset.location}</span>
                  </div>
                  <div className="flex flex-wrap gap-2" data-id="element-1453">
                    <span className={`px-2 py-1 rounded-full text-xs font-medium ${asset.status === 'Aktif' ? 'bg-green-100 text-green-800' : asset.status === 'Perlu Perawatan' ? 'bg-yellow-100 text-yellow-800' : asset.status === 'Akan Habis' ? 'bg-orange-100 text-orange-800' : 'bg-red-100 text-red-800'}`} data-id="element-1454">
                      {asset.status}
                    </span>
                    <span className={`px-2 py-1 rounded-full text-xs font-medium ${asset.classification === 'Sangat Rahasia' ? 'bg-red-100 text-red-800' : asset.classification === 'Rahasia' ? 'bg-orange-100 text-orange-800' : 'bg-blue-100 text-blue-800'}`} data-id="element-1455">
                      {asset.classification}
                    </span>
                    <span className="px-2 py-1 rounded-full text-xs font-medium bg-purple-100 text-purple-800" data-id="element-1456">
                      {asset.category}
                    </span>
                  </div>
                </div>
                <div className="flex space-x-2" data-id="element-1457">
                  <button onClick={handleEditAsset} className="p-2 bg-accent-info text-white rounded-md hover:bg-opacity-90" data-id="element-1458">
                    <EditIcon size={16} data-id="element-1459" />
                  </button>
                  <button onClick={handleDeleteAsset} className="p-2 bg-accent-red text-white rounded-md hover:bg-opacity-90" data-id="element-1460">
                    <TrashIcon size={16} data-id="element-1461" />
                  </button>
                  <button onClick={handleDownloadDetails} className="p-2 bg-secondary text-white rounded-md hover:bg-opacity-90" data-id="element-1462">
                    <DownloadIcon size={16} data-id="element-1463" />
                  </button>
                </div>
              </div>
              <div className="grid grid-cols-2 gap-4" data-id="element-1464">
                <div className="border border-gray-200 rounded-lg p-4" data-id="element-1465">
                  <h4 className="text-sm font-medium text-gray-500 mb-3" data-id="element-1466">
                    INFORMASI DASAR
                  </h4>
                  <table className="w-full text-sm" data-id="element-1467">
                    <tbody data-id="element-1468">
                      <tr data-id="element-1469">
                        <td className="py-1.5 text-gray-600" data-id="element-1470">Serial Number</td>
                        <td className="py-1.5 font-medium text-gray-900" data-id="element-1471">
                          {assetDetails.serialNumber}
                        </td>
                      </tr>
                      <tr data-id="element-1472">
                        <td className="py-1.5 text-gray-600" data-id="element-1473">Manufacturer</td>
                        <td className="py-1.5 font-medium text-gray-900" data-id="element-1474">
                          {assetDetails.manufacturer}
                        </td>
                      </tr>
                      <tr data-id="element-1475">
                        <td className="py-1.5 text-gray-600" data-id="element-1476">Model</td>
                        <td className="py-1.5 font-medium text-gray-900" data-id="element-1477">
                          {assetDetails.model}
                        </td>
                      </tr>
                      <tr data-id="element-1478">
                        <td className="py-1.5 text-gray-600" data-id="element-1479">
                          Tanggal Pembelian
                        </td>
                        <td className="py-1.5 font-medium text-gray-900" data-id="element-1480">
                          {assetDetails.purchaseDate}
                        </td>
                      </tr>
                      <tr data-id="element-1481">
                        <td className="py-1.5 text-gray-600" data-id="element-1482">
                          Garansi Berakhir
                        </td>
                        <td className="py-1.5 font-medium text-gray-900" data-id="element-1483">
                          {assetDetails.warrantyEnd}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div className="border border-gray-200 rounded-lg p-4" data-id="element-1484">
                  <h4 className="text-sm font-medium text-gray-500 mb-3" data-id="element-1485">
                    STATUS & KONDISI
                  </h4>
                  <table className="w-full text-sm" data-id="element-1486">
                    <tbody data-id="element-1487">
                      <tr data-id="element-1488">
                        <td className="py-1.5 text-gray-600" data-id="element-1489">Nilai Aset</td>
                        <td className="py-1.5 font-medium text-gray-900" data-id="element-1490">
                          {assetDetails.value}
                        </td>
                      </tr>
                      <tr data-id="element-1491">
                        <td className="py-1.5 text-gray-600" data-id="element-1492">Kondisi</td>
                        <td className="py-1.5 font-medium text-gray-900" data-id="element-1493">
                          {assetDetails.condition}
                        </td>
                      </tr>
                      <tr data-id="element-1494">
                        <td className="py-1.5 text-gray-600" data-id="element-1495">
                          Terakhir Diperbarui
                        </td>
                        <td className="py-1.5 font-medium text-gray-900" data-id="element-1496">
                          {asset.lastUpdate}
                        </td>
                      </tr>
                      <tr data-id="element-1497">
                        <td className="py-1.5 text-gray-600" data-id="element-1498">
                          Pemeliharaan Terakhir
                        </td>
                        <td className="py-1.5 font-medium text-gray-900" data-id="element-1499">
                          {assetDetails.lastMaintenance}
                        </td>
                      </tr>
                      <tr data-id="element-1500">
                        <td className="py-1.5 text-gray-600" data-id="element-1501">
                          Pemeliharaan Berikutnya
                        </td>
                        <td className="py-1.5 font-medium text-gray-900" data-id="element-1502">
                          {assetDetails.nextMaintenance}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              {asset.status !== 'Aktif' && <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4 flex items-start" data-id="element-1503">
                  <AlertTriangleIcon size={20} className="text-yellow-600 mr-3 mt-0.5" data-id="element-1504" />
                  <div data-id="element-1505">
                    <h4 className="font-medium text-secondary mb-1" data-id="element-1506">
                      Perhatian
                    </h4>
                    <p className="text-sm text-gray-700" data-id="element-1507">
                      {assetDetails.notes}
                    </p>
                  </div>
                </div>}
              <div className="border border-gray-200 rounded-lg p-4" data-id="element-1508">
                <h4 className="text-sm font-medium text-gray-500 mb-3" data-id="element-1509">
                  CATATAN & DESKRIPSI
                </h4>
                <p className="text-sm text-gray-700" data-id="element-1510">
                  {asset.category === 'Server & Komputasi' ? `${asset.name} merupakan perangkat komputasi utama yang digunakan untuk memproses dan menyimpan data operasional. Perangkat ini terhubung dengan jaringan utama dan memiliki redundansi N+1 untuk menjamin ketersediaan layanan.` : asset.category === 'Software & Lisensi' ? `${asset.name} adalah perangkat lunak kritikal untuk operasional sistem. Lisensi mencakup dukungan teknis 24/7 dan pembaruan keamanan berkala.` : asset.category === 'Jaringan & Komunikasi' ? `${asset.name} berfungsi sebagai tulang punggung konektivitas antar unit kerja. Perangkat ini mendukung enkripsi data tingkat tinggi dan segmentasi jaringan aman.` : asset.category === 'Keamanan Siber' ? `${asset.name} bertugas melindungi infrastruktur dari ancaman siber eksternal dan internal. Dilengkapi dengan fitur IDS/IPS dan inspeksi trafik mendalam.` : `${asset.name} merupakan fondasi digital untuk layanan virtualisasi dan cloud private BIN. Mendukung skalabilitas dinamis dan manajemen resource terpusat.`}
                </p>
              </div>
              <div className="border border-gray-200 rounded-lg p-4" data-id="element-1511">
                <h4 className="text-sm font-medium text-gray-500 mb-3" data-id="element-1512">
                  RIWAYAT AKTIVITAS
                </h4>
                <div className="space-y-3" data-id="element-1513">
                  <div className="flex items-start" data-id="element-1514">
                    <div className="bg-neutral-light p-1.5 rounded-full mr-3" data-id="element-1515">
                      <CalendarIcon size={14} className="text-secondary" data-id="element-1516" />
                    </div>
                    <div data-id="element-1517">
                      <p className="text-sm font-medium text-secondary" data-id="element-1518">
                        Pemeliharaan Rutin
                      </p>
                      <p className="text-xs text-gray-500" data-id="element-1519">
                        {assetDetails.lastMaintenance} oleh Teknisi PT Teknologi
                        Aman
                      </p>
                    </div>
                  </div>
                  <div className="flex items-start" data-id="element-1520">
                    <div className="bg-neutral-light p-1.5 rounded-full mr-3" data-id="element-1521">
                      <EditIcon size={14} className="text-secondary" data-id="element-1522" />
                    </div>
                    <div data-id="element-1523">
                      <p className="text-sm font-medium text-secondary" data-id="element-1524">
                        Update Data Aset
                      </p>
                      <p className="text-xs text-gray-500" data-id="element-1525">
                        2023-02-10 oleh Ahmad Supriyadi
                      </p>
                    </div>
                  </div>
                  <div className="flex items-start" data-id="element-1526">
                    <div className="bg-neutral-light p-1.5 rounded-full mr-3" data-id="element-1527">
                      <CalendarIcon size={14} className="text-secondary" data-id="element-1528" />
                    </div>
                    <div data-id="element-1529">
                      <p className="text-sm font-medium text-secondary" data-id="element-1530">
                        Inspeksi Tahunan
                      </p>
                      <p className="text-xs text-gray-500" data-id="element-1531">
                        2022-11-05 oleh Tim Audit Internal
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="space-y-4" data-id="element-1532">
              <div className="border border-gray-200 rounded-lg p-4" data-id="element-1533">
                <h4 className="text-sm font-medium text-gray-500 mb-3" data-id="element-1534">
                  AI HEALTH SCORE
                </h4>
                <div className="flex flex-col items-center" data-id="element-1535">
                  <div className="relative w-32 h-32" data-id="element-1536">
                    <svg className="w-full h-full" viewBox="0 0 100 100" data-id="element-1537">
                      <circle className="text-gray-200" strokeWidth="8" stroke="currentColor" fill="transparent" r="40" cx="50" cy="50" data-id="element-1538" />
                      <circle className={`${asset.status === 'Aktif' ? 'text-green-500' : asset.status === 'Perlu Perawatan' ? 'text-yellow-500' : asset.status === 'Akan Habis' ? 'text-orange-500' : 'text-red-500'}`} strokeWidth="8" strokeDasharray="251.2" strokeDashoffset={251.2 * (1 - (asset.status === 'Aktif' ? 0.85 : asset.status === 'Perlu Perawatan' ? 0.65 : asset.status === 'Akan Habis' ? 0.45 : 0.25))} strokeLinecap="round" stroke="currentColor" fill="transparent" r="40" cx="50" cy="50" data-id="element-1539" />
                    </svg>
                    <div className="absolute inset-0 flex items-center justify-center" data-id="element-1540">
                      <span className="text-2xl font-bold text-secondary" data-id="element-1541">
                        {asset.status === 'Aktif' ? '85%' : asset.status === 'Perlu Perawatan' ? '65%' : asset.status === 'Akan Habis' ? '45%' : '25%'}
                      </span>
                    </div>
                  </div>
                  <p className="text-sm text-gray-600 mt-2" data-id="element-1542">
                    {asset.status === 'Aktif' ? 'Kondisi Optimal' : asset.status === 'Perlu Perawatan' ? 'Perlu Pemeliharaan' : asset.status === 'Akan Habis' ? 'Perlu Perpanjangan' : 'Perlu Penggantian'}
                  </p>
                </div>
                <div className="mt-4" data-id="element-1543">
                  <h5 className="text-xs font-medium text-gray-500 mb-2" data-id="element-1544">
                    REKOMENDASI AI
                  </h5>
                  <p className="text-sm text-gray-700 bg-neutral-light p-3 rounded-lg" data-id="element-1545">
                    {asset.status === 'Aktif' ? 'Lakukan pemeliharaan rutin sesuai jadwal untuk mempertahankan kinerja optimal.' : asset.status === 'Perlu Perawatan' ? 'Jadwalkan pemeliharaan dalam 30 hari ke depan untuk mencegah penurunan kinerja lebih lanjut.' : asset.status === 'Akan Habis' ? 'Ajukan perpanjangan lisensi segera. Estimasi biaya perpanjangan: Rp 275.000.000.' : 'Aset perlu diganti segera. Estimasi biaya penggantian: Rp 1.250.000.000.'}
                  </p>
                </div>
              </div>
              <div className="border border-gray-200 rounded-lg p-4" data-id="element-1546">
                <h4 className="text-sm font-medium text-gray-500 mb-3" data-id="element-1547">
                  DOKUMEN TERKAIT
                </h4>
                <div className="space-y-2" data-id="element-1548">
                  <button className="w-full flex items-center justify-between p-2 border border-gray-200 rounded-md hover:bg-neutral-light" data-id="element-1549">
                    <div className="flex items-center" data-id="element-1550">
                      <div className="bg-blue-100 p-1.5 rounded-md mr-2" data-id="element-1551">
                        <DownloadIcon size={14} className="text-blue-600" data-id="element-1552" />
                      </div>
                      <span className="text-sm" data-id="element-1553">Dokumen Spesifikasi</span>
                    </div>
                    <span className="text-xs text-gray-500" data-id="element-1554">PDF, 2.4 MB</span>
                  </button>
                  <button className="w-full flex items-center justify-between p-2 border border-gray-200 rounded-md hover:bg-neutral-light" data-id="element-1555">
                    <div className="flex items-center" data-id="element-1556">
                      <div className="bg-green-100 p-1.5 rounded-md mr-2" data-id="element-1557">
                        <DownloadIcon size={14} className="text-green-600" data-id="element-1558" />
                      </div>
                      <span className="text-sm" data-id="element-1559">Laporan Pemeliharaan</span>
                    </div>
                    <span className="text-xs text-gray-500" data-id="element-1560">XLSX, 1.8 MB</span>
                  </button>
                  <button className="w-full flex items-center justify-between p-2 border border-gray-200 rounded-md hover:bg-neutral-light" data-id="element-1561">
                    <div className="flex items-center" data-id="element-1562">
                      <div className="bg-purple-100 p-1.5 rounded-md mr-2" data-id="element-1563">
                        <DownloadIcon size={14} className="text-purple-600" data-id="element-1564" />
                      </div>
                      <span className="text-sm" data-id="element-1565">Kontrak Pengadaan</span>
                    </div>
                    <span className="text-xs text-gray-500" data-id="element-1566">PDF, 3.5 MB</span>
                  </button>
                </div>
              </div>
              <div className="border border-gray-200 rounded-lg p-4" data-id="element-1567">
                <h4 className="text-sm font-medium text-gray-500 mb-3" data-id="element-1568">
                  TINDAKAN CEPAT
                </h4>
                <div className="space-y-2" data-id="element-1569">
                  <button className="w-full py-2 bg-accent-info text-white rounded-md hover:bg-opacity-90 text-sm" data-id="element-1570">
                    Jadwalkan Pemeliharaan
                  </button>
                  <button className="w-full py-2 bg-primary text-secondary rounded-md hover:bg-opacity-90 text-sm" data-id="element-1571">
                    Perbarui Data Aset
                  </button>
                  <button className="w-full py-2 border border-secondary text-secondary rounded-md hover:bg-neutral-light text-sm" data-id="element-1572">
                    Lihat Riwayat Lengkap
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="p-4 border-t border-gray-200 flex justify-end" data-id="element-1573">
          <button onClick={onClose} className="px-4 py-2 border border-gray-300 rounded-md text-sm mr-2 hover:bg-gray-100" data-id="element-1574">
            Tutup
          </button>
          <button className="px-4 py-2 bg-secondary text-white rounded-md hover:bg-opacity-90 text-sm" onClick={handleEditAsset} data-id="element-1575">
            Edit Aset
          </button>
        </div>
      </div>
    </div>;
};